import styled from 'styled-components';
import { Image } from 'components/Avatar/Styles'

export const Wrapper = styled.aside`
  border-right: .1rem solid ${(props) => props.theme.colors.darkBlue};
  position: fixed;
  width: ${(props) => props.theme.consts.navBar};
  height: 100%;
  
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 2.4rem 0 1.6rem 0;

  ${Image} {
    margin-top: 1.2rem;
  }

`;

export const And = styled.span`

  ${(props) => props.theme.fonts.interSemibold12};
  color: ${(props) => props.theme.colors.white100};

  margin: .4rem 0 .8rem 0;
  user-select: none;

`;

export const Separator = styled.div`

  width: 100%;
  height: .1rem;
  background-color: ${(props) => props.theme.colors.darkBlue};

`;

export const ExitButton = styled.button`

  position: absolute;
  bottom: 2.3rem;

`;